var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3904 3.05721C20.9111 2.53651 21.7553 2.53651 22.276 3.05721L28.9427 9.72388C29.4634 10.2446 29.4634 11.0888 28.9427 11.6095L13.6093 26.9428C13.4326 27.1195 13.2098 27.243 12.9663 27.2992L4.29968 29.2992C3.85173 29.4026 3.38213 29.2679 3.05705 28.9428C2.73198 28.6178 2.5973 28.1482 2.70067 27.7002L4.70067 19.0335C4.75687 18.79 4.88035 18.5672 5.05705 18.3905L20.3904 3.05721ZM6.75811 21.9772L5.77875 26.2211L10.0227 25.2418L6.75811 21.9772ZM12.6665 24.1144L7.88548 19.3334L21.3332 5.88564L26.1142 10.6667L12.6665 24.1144Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c3b4e3b9f68ee57c59817507cd938cde.svg";
export { ForwardRef as ReactComponent };